<div *ngIf="isPageLoading" class="page-load">
    <div class="d-flex justify-content-center loading">
        <!-- <img class="mx-auto d-block" src="assets/images/process.gif" width="120px" /> -->
        <nz-spin class="d-block" nzSimple  [nzSize]="'large'"></nz-spin>
    </div>
</div>